import React, { useState } from 'react';
import { NavLink, Link as RouterLink } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

function Navbar() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(!open);
  };

  const closeMenu = () => {
    setOpen(false);
  };

  const handleLogoClick = () => {
    closeMenu();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Nav links helper to keep it DRY and clean
  const navItems = [
    { label: t('nav.home'), path: '/', isHash: false },
    { label: t('nav.coaching'), path: '/#1on1coaching', isHash: true },
    { label: t('nav.training'), path: '/training', isHash: false },
    { label: t('nav.nutrition'), path: '/nutrition', isHash: false },
    { label: t('nav.testimonials'), path: '/#testimonials', isHash: true },
    { label: t('nav.aboutMe'), path: '/aboutme', isHash: false },
    { label: t('nav.contact'), path: '/#contact', isHash: true },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-[#162E3B] border-b border-[#FFD82D]/20 shadow-md transition-all duration-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4 flex items-center justify-between">
        
        {/* Brand Logo */}
        <RouterLink to="/" onClick={handleLogoClick} className="text-xl lg:text-2xl font-extrabold text-white tracking-wide hover:opacity-90 focus:outline-none">
          Nevski<span className="text-[#FFD82D]">Fit</span>
        </RouterLink>

        {/* Desktop Navigation Links */}
        <div className="hidden lg:flex items-center space-x-6">
          {navItems.map((item, index) => {
            const className = ({ isActive }) => 
              `text-base font-semibold transition-all py-2 px-3 rounded-md hover:text-[#FFD82D] focus:outline-none focus:ring-2 focus:ring-[#FFD82D] ${
                isActive ? 'text-[#FFD82D] border-b-2 border-[#FFD82D]' : 'text-white'
              }`;

            if (item.isHash) {
              return (
                <Link
                  key={index}
                  to={item.path}
                  className="text-base font-semibold text-white transition-all py-2 px-3 rounded-md hover:text-[#FFD82D] focus:outline-none focus:ring-2 focus:ring-[#FFD82D]"
                >
                  {item.label}
                </Link>
              );
            } else {
              return (
                <NavLink
                  key={index}
                  to={item.path}
                  className={className}
                  end
                >
                  {item.label}
                </NavLink>
              );
            }
          })}
          <LanguageSwitcher className="ml-2" />
        </div>

        {/* Mobile menu button */}
        <div className="flex lg:hidden items-center gap-3">
          <LanguageSwitcher />
          <button
            onClick={handleOpen}
            type="button"
            className="text-white hover:text-[#FFD82D] focus:outline-none focus:ring-2 focus:ring-[#FFD82D] p-2 rounded-md"
            aria-label={t('nav.toggleMenu')}
          >
            <FontAwesomeIcon icon={open ? faXmark : faBars} className="h-7 w-7" />
          </button>
        </div>
      </div>

      {/* Mobile Drawer Overlay */}
      {open && (
        <div className="lg:hidden bg-[#162E3B] border-t border-[#FFD82D]/10 px-6 py-4 space-y-3 shadow-inner">
          <ul className="flex flex-col space-y-4">
            {navItems.map((item, index) => (
              <li key={index} className="border-b border-[#FFD82D]/5 pb-2 last:border-0 last:pb-0">
                {item.isHash ? (
                  <Link
                    to={item.path}
                    onClick={closeMenu}
                    className="block text-base font-bold text-white py-2 hover:text-[#FFD82D] focus:outline-none"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <NavLink
                    to={item.path}
                    onClick={closeMenu}
                    className={({ isActive }) =>
                      `block text-base font-bold py-2 hover:text-[#FFD82D] focus:outline-none ${
                        isActive ? 'text-[#FFD82D]' : 'text-white'
                      }`
                    }
                    end
                  >
                    {item.label}
                  </NavLink>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
